// mutations
const RETAINEDS_ALL = (state, retaineds) => {
  if (retaineds.code === 1) {
    state.retaineds = retaineds.data
    state.status = 'success'
  } else {
    alert(retaineds.message)
    state.status = 'error'
  }
}

const RETAINEDS_FORM = (state, retaineds) => {
  if (retaineds.code === 1) {
    state.retaineds = retaineds.data
    state.status = 'success'
  } else {
    alert(retaineds.message)
    state.status = 'error'
  }
}

const RETAINEDS_SHOW = (state, retaineds) => {
  if (retaineds.code === 1) {
    state.retaineds = retaineds.data
    state.status = 'success'
  } else {
    alert(retaineds.message)
    state.status = 'error'
  }
}

const RETAINEDS_CREATE = (state, retaineds) => {
  if (retaineds.code === 1) {
    state.retaineds = retaineds.data
    state.status = 'success'
  } else {
    alert(retaineds.message)
    state.status = 'error'
  }
}

const RETAINEDS_UPDATE = (state, retaineds) => {
  if (retaineds.code === 1) {
    state.retaineds = retaineds.data
    state.status = 'success'
  } else {
    alert(retaineds.message)
    state.status = 'error'
  }
}

const RETAINEDS_DELETE = (state, retaineds) => {
  if (retaineds.code === 1) {
    state.retaineds = retaineds.data
    state.status = 'success'
  } else {
    alert(retaineds.message)
    state.status = 'error'
  }
}

export default {
  RETAINEDS_ALL,
  RETAINEDS_FORM,
  RETAINEDS_SHOW,
  RETAINEDS_CREATE,
  RETAINEDS_UPDATE,
  RETAINEDS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/retaineds/mutations.js